import Vue from "vue";
import VueRouter from "vue-router";

import Atendimento from "../views/atendimento/Atendimento.vue";
import ChamadosAbertos from "../views/chamados/ChamadosAbertos";
import ChamadosFechados from "../views/chamados/ChamadosFechados";
import BuscarChamados from "../views/chamados/BuscarChamados.vue";
import DetalheChamado from "../views/chamados/DetalheChamado";
import Admin from "../views/admin/Admin.vue";
import ListaContextos from "../views/admin/contexto/ListaContextos.vue";
import ContextoAdmin from "../views/admin/contexto/ContextoAdmin.vue";
import ArvoreForm from "../views/admin/contexto/ArvoreForm.vue";
import UsuarioInstitucionalAdmin from "../views/admin/usuario-institucional/UsuarioInstitucionalAdmin.vue";
import UsuarioInstitucionalForm from "../views/admin/usuario-institucional/UsuarioInstitucionalForm.vue";
import Home from "../views/Home.vue";
import PageNotFound from "../views/error/404.vue";
import Page400 from "../views/error/400.vue";
import Page403 from "../views/error/403.vue";
import Page500 from "../views/error/500.vue";
import Doc from "../views/admin/contexto/Doc.vue";
import store from "../vuex/store";

Vue.use(VueRouter);

const routes = [
    {
        path: "/400",
        name: "400",
        component: Page400,
    },
    {
        path: "/403",
        name: "403",
        component: Page403,
    },
    {
        path: "/500",
        name: "500",
        component: Page500,
    },
    {
        path: "/",
        alias: "/home",
        name: "Home",
        component: Home,
    },
    {
        path: "/atendimento",
        name: "Atendimento",
        component: Atendimento,
        meta: {
            restricted: true,
        },
    },
    {
        path: "/chamados/abertos",
        name: "ChamadosAbertos",
        component: ChamadosAbertos,
        meta: {
            restricted: true,
        },
    },
    {
        path: "/chamados/fechados",
        name: "ChamadosFechados",
        component: ChamadosFechados,
        meta: {
            restricted: true,
        },
    },
    {
        path: "/chamados/detalhe/:id",
        name: "DetalheChamado",
        component: DetalheChamado,
        meta: {
            restricted: true,
        },
    },
    {
        path: "/chamados/buscar",
        name: "BuscarChamados",
        component: BuscarChamados,
        meta: {
            restricted: true,
        },
    },
    {
        path: "/admin",
        name: "Admin",
        component: Admin,
        meta: {
            adminRestricted: true,
        },
    },
    {
        path: "/admin/contexto",
        name: "ListaContextos",
        component: ListaContextos,
        meta: {
            adminRestricted: true,
        },
    },
    {
        path: "/admin/contexto/:id",
        name: "ContextoAdmin",
        component: ContextoAdmin,
        props: true,
        meta: {
            adminRestricted: true,
        },
    },
    {
        path: "/admin/contexto/arvore/doc",
        name: "DocArvore",
        component: Doc,
        meta: {
            adminRestricted: true,
        },
    },
    {
        path: "/admin/contexto/arvore/new",
        name: "NovaArvore",
        component: ArvoreForm,
        meta: {
            adminRestricted: true,
        },
    },
    {
        path: "/admin/contexto/arvore/:id",
        name: "DetalheArvore",
        component: ArvoreForm,
        meta: {
            adminRestricted: true,
        },
    },
    {
        path: "/admin/usuario-institucional",
        name: "UsuarioInstitucionalAdmin",
        component: UsuarioInstitucionalAdmin,
        meta: {
            adminRestricted: true,
        },
    },
    {
        path: "/admin/usuario-institucional/new",
        name: "NovoUsuarioInstitucional",
        component: UsuarioInstitucionalForm,
        meta: {
            adminRestricted: true,
        },
    },
    {
        path: "/admin/usuario-institucional/:id",
        name: "EditarUsuarioInstitucional",
        component: UsuarioInstitucionalForm,
        meta: {
            adminRestricted: true,
        },
    },
    {
        path: "/404",
        name: "NotFound",
        component: PageNotFound,
    },
    {
        path: "*",
        name: "404",
        component: PageNotFound,
    },
];
const router = new VueRouter({
    mode: "history",
    routes,
});

const paginaRestrita = (to) => {
    return to.meta.restricted && !store.getters["autenticacao/isAuthenticated"];
};

const paginaAdmin = (to) => {
    return to.meta.adminRestricted && !store.getters["autenticacao/isAdmin"];
};

const redirecionarParaLogin = (next) => {
    store.dispatch("autenticacao/" + "LOGIN");
    next(false);
};

const processarAdmin = (next) => {
    if (!store.getters["autenticacao/isAuthenticated"]) {
        redirecionarParaLogin(next);
    } else {
        next("403");
    }
};

const checkSession = async (to, _from, next) => {
    if (!store.getters["autenticacao/sessionCarregada"]) {
        await store.dispatch("autenticacao/" + "FETCH_SESSION");
    }

    if (paginaAdmin(to)) {
        processarAdmin(next);
    } else if (paginaRestrita(to)) {
        redirecionarParaLogin(next);
    } else {
        next();
    }
};

router.beforeEach(checkSession);

function atualizarTitulo() {
    const contexto = store.getters["contexto/contexto"];
    document.title = contexto ? `Chamado | ${contexto.sigla}` : "Chamado";
}

router.afterEach(atualizarTitulo);

store.watch(
    (state, getters) => getters["contexto/contexto"],
    () => {
        atualizarTitulo();
    },
);

window.addEventListener("storage", (event) => {
    if (event.key === "contexto") {
        const novoContexto = JSON.parse(event.newValue);

        // Atualiza o Vuex
        store.commit("contexto/SET_CONTEXT", novoContexto);
    }

    if (event.key === "usuarioInstitucionalAtivo") {
        const novoUsuarioInstitucional = JSON.parse(event.newValue);

        // Atualiza o Vuex
        store.commit(
            "autenticacao/setUsuarioInstitucionalAtivo",
            novoUsuarioInstitucional,
        );
    }
});

export default router;
